import type { Components, Theme } from '@mui/material/styles'
import { SelectDropdownIcon } from '@/shared/components/SelectDropdownIcon'
import { surfaceAuthCanvas, surfaceAuthCard } from './designTokens'

export const componentOverrides: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        overflowX: 'clip',
        maxWidth: '100%',
      },
      body: {
        backgroundColor: surfaceAuthCanvas,
        overflowX: 'clip',
        maxWidth: '100%',
      },
      '#root': {
        minHeight: '100dvh',
        maxWidth: '100%',
        overflowX: 'clip',
        backgroundColor: surfaceAuthCanvas,
      },
      img: {
        maxWidth: '100%',
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        [theme.breakpoints.down('sm')]: {
          margin: 16,
          width: 'calc(100% - 32px)',
          maxWidth: 'calc(100% - 32px)',
          maxHeight: 'calc(100dvh - 32px)',
        },
      }),
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ theme }) => ({
        [theme.breakpoints.down('sm')]: {
          paddingLeft: 16,
          paddingRight: 16,
        },
      }),
    },
  },
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: {
      root: { textTransform: 'none', fontWeight: 600 },
    },
  },
  MuiCard: {
    defaultProps: { variant: 'outlined' },
  },
  MuiTextField: {
    defaultProps: { size: 'small', variant: 'outlined' },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        backgroundColor: surfaceAuthCard,
        backgroundImage: 'none',
      },
      input: {
        background: surfaceAuthCard,
        backgroundColor: surfaceAuthCard,
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: surfaceAuthCard,
        backgroundImage: 'none',
        '&:hover': {
          backgroundColor: surfaceAuthCard,
          backgroundImage: 'none',
        },
        '&.Mui-focused': {
          backgroundColor: surfaceAuthCard,
          backgroundImage: 'none',
        },
        '&.Mui-disabled': {
          backgroundColor: surfaceAuthCard,
          backgroundImage: 'none',
        },
      },
      input: {
        background: surfaceAuthCard,
        backgroundColor: surfaceAuthCard,
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      IconComponent: SelectDropdownIcon,
    },
    styleOverrides: {
      icon: {
        width: 24,
        height: 24,
        top: 'calc(50% - 12px)',
        right: 15,
        color: '#0d1b2a',
      },
    },
  },
}
